













import { Component, Vue } from 'vue-property-decorator';
import VualtoFooter from '@/views/layout/VualtoFooter.vue';
import VualtoNav from '@/views/layout/VualtoNav.vue';

@Component({ components: { VualtoFooter, VualtoNav } })
export default class App extends Vue { }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue